import en from './en';
import ru from './ru';
import { addResources } from '../../../locales';

addResources({ en, ru });
